export const CONSULTATION_TYPE_LIST = [
  {
    id: 1,
    label: "In-Clinic Consultation",
    value: "in-clinic",
  },
  {
    id: 2,
    label: "Tele Consultation",
    value: "online",
  },
  {
    id: 3,
    label: "Instant Consultation",
    value: "instant",
  },
];

export const CONSULTATIONLIST = {
  INSTANT: "instant",
};
